import sum from 'lodash/sum'

import type { SelectIntellifloCampaignChannelOption } from '@/pages/intellifloIntegration/components/SelectIntellifloCampaignChannel'
import { ConfigSection } from '@/pages/intellifloIntegration/types'

export const DO_NOT_MAP_USER_OPTION = {
  label: "Don't map user",
  value: undefined,
}

// The default "Don't set" option for the default campaign channel picker. Its
// empty-string value maps to a null campaignChannel in config, which is the
// default for all until a channel is picked.
export const DO_NOT_USE_CAMPAIGN_CHANNEL_OPTION: SelectIntellifloCampaignChannelOption =
  {
    label: "Don't set",
    value: '',
  }

export const DEFAULT_USER_MAPPING_ID = -1
export const DEFAULT_ADVISER_MAPPING_ID = 0

export const UPDATE_INTEGRATION_CONFIG_SOURCE = {
  addCompany: 'addCompany',
  removeCompany: 'removeCompany',
  enableOrDisableCompany: 'enableOrDisableCompany',
  copyMapping: 'copyMapping',
}

/** How long the copy-mapping banner shows its result before hiding itself. */
export const COPY_MAPPING_SUCCESS_DURATION: number = 4000

/** Longer than the success duration because there is more to read. */
export const COPY_MAPPING_WARNING_DURATION: number = 8000

export const ADVISER_MAPPING_TABLE = {
  columnWidths: {
    company: 240,
    rqUser: 200,
    mappedIntellifloUser: 340,
  },

  get tableWidth() {
    return (
      sum(Object.values(this.columnWidths)) + 2 // (2px is for the borders)
    )
  },
}

export const FALLBACK_ADVISER_TABLE = {
  columnWidths: {
    company: 240,
    rqUser: 260,
    intellifloUser: 300,
  },

  get tableWidth() {
    return (
      sum(Object.values(this.columnWidths)) + 2 // (2px is for the borders)
    )
  },
}

export const REFERRAL_DETAILS_TABLE = {
  columnWidths: {
    documents: 230,
    category: 230,
    subcategory: 230,
  },

  get tableWidth() {
    return (
      sum(Object.values(this.columnWidths)) + 2 // (2px is for the borders)
    )
  },
}

export const INTRODUCERS_TABLE = {
  columnWidths: {
    introducerId: 200,
    name: 360,
    status: 120,
  },

  get tableWidth() {
    return (
      sum(Object.values(this.columnWidths)) + 2 // (2px is for the borders)
    )
  },
}

export const CAMPAIGN_AND_SOURCE_DETAILS_TABLE = {
  columnWidths: {
    professionalIntroducer: 210,
    campaignType: 180,
    campaignSource: 180,
    introducer: 180,
    action: 50,
  },

  get columnCount() {
    return Object.keys(this.columnWidths).length
  },

  get tableWidth() {
    return (
      sum(Object.values(this.columnWidths)) + 2 // (2px is for the borders)
    )
  },
}

export const COMPANY_DASHBOARD_LAYOUT_MAIN_CONTENT =
  'company-dashboard-main-content'

export const MAX_NUM_ROWS_TO_SHOW_BY_DEFAULT = 5

export const MODE_GROUP = 'group'
export const MODE_NONE = 'none'

export const CONFIG_SECTION: Record<ConfigSection, ConfigSection> = {
  selectProfilesToIntegrate: 'selectProfilesToIntegrate',
  importFromIntelliflo: 'importFromIntelliflo',
  duplicateHandling: 'duplicateHandling',
  statusMapping: 'statusMapping',
  statusPriority: 'statusPriority',
  opportunityTypeMapping: 'opportunityTypeMapping',
  opportunityStatusMapping: 'opportunityStatusMapping',
  serviceCase: 'serviceCase',
  introducerMapping: 'introducerMapping',
  userMapping: 'userMapping',
  fallbackIndividual: 'fallbackIndividual',
  fileStorageConfiguration: 'fileStorageConfiguration',
  groupLimit: 'groupLimit',
}
